import { $post } from '@/api/request'
// 资产管理
export function compAssetsInfo (portType, data = {}) {
  return $post({
    url: `/compAssetsInfo/${portType}`,
    data
  })
}
// 资产领用申请
export function compApplyAssetsReceive (portType, data = {}) {
  return $post({
    url: `/compApplyAssetsReceive/${portType}`,
    data
  })
}
// 资产采购申请
export function compApplyAssetsPurchase (portType, data = {}) {
  return $post({
    url: `/compApplyAssetsPurchase/${portType}`,
    data
  })
}